import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router';
import { useDispatch } from 'react-redux';
import { AuthActions, AuthUser } from 'common/auth/auth_context';
import { UserSubType } from 'common/graphql/types';
import { find, includes } from 'lodash';

const useStudySiteUpdate = (activeUser?: AuthUser) => {
    const location = useLocation();
    const history = useHistory();
    const dispatch = useDispatch();

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const studyId = queryParams.get('studyId');
        const siteId = queryParams.get('siteId');

        if (
            studyId &&
            includes(
                [
                    UserSubType.SITE,
                    UserSubType.MONITOR,
                    UserSubType.DATA_MANAGER,
                    UserSubType.INSPECTOR,
                    UserSubType.PRODUCT_SUPPORT,
                    UserSubType.DATA_CHANGE_SUPPORT,
                ],
                activeUser?.subType as UserSubType
            )
        ) {
            const study = activeUser?.userStudies ? find(activeUser.userStudies, ['studyId', studyId]) : undefined;
            const site = siteId && study ? find(study.userStudySites, ['siteId', siteId]) : undefined;
            dispatch(
                AuthActions.updateActiveStudySite({
                    site,
                    study,
                })
            );
        }

        if (studyId || siteId) {
            queryParams.delete('studyId');
            queryParams.delete('siteId');
            const newSearch = queryParams.toString();
            history.replace({
                pathname: location.pathname,
                search: newSearch.length > 0 ? `?${newSearch}` : '',
            });
        }
    }, [location.search]);
};

export default useStudySiteUpdate;
